export const GENERAL_SETTINGS_TABS = {
  ASSISTANT_SETTINGS: "Agent Settings"
};

export const ERROR_TEXTS = {
  DASHBOARD_ID: "Please enter a dashboard id",
  GROUP_IDS: "Please enter a group id",
  GROUP_IDS_NUMBER: "Please enter a single numerical value"
};

export const ASSISTANT_SETTINGS_TAB_SECTIONS = {
  ACCOUNT: "Account",
  CONFIGURATION_ID: "Configuration Id",
  ASSISTANT_NAME: "Agent Name",
  ERROR_RESPONSE_TEXT: "Error Response Text",
  LOOKER: {
    TITLE: "Looker",
    FIELDS: {
      DASHBOARD_ID: "Dashboard ID",
      GROUP_ID: "Group ID",
      SKILLS_DASHBOARDS: "Skills Dashboards"
    }
  }
};

export const PUBLISH_BUTTON = {
  text: "Save Changes"
};

// These names should be corresponding to the names we receive from the backend
export const ASSISTANT_SETTINGS_TAB_FIELDS = {
  accountName: "accountName",
  clientName: "clientName",
  friendlyName: "friendlyName",
  errorResponseText: "errorResponseText",
  accountTimezone: "accountTimezone",
  agentTimezone: "agentTimezone",
  dashboardId: "dashboardId",
  groupIds: "groupIds",
  skillsDashboards: "skillsDashboards"
};
